import RepositoryError from "repository/error/RepositoryError";

export default class BadRequestError extends RepositoryError {
    constructor(url) {
        super(`Bad Request: ${url}`);
    }
}